import React, { useState } from 'react';
import { API_ENDPOINTS } from '../config/api';
import { isAuthenticated, getAuthHeaders } from '../utils/auth';
import './DesktopAppDownload.css';

function DesktopAppDownload() {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    setIsDownloading(true);
    
    try {
      // Check for auth (cookie or token)
      if (!isAuthenticated()) {
        alert('Please log in to download the desktop app.');
        setIsDownloading(false);
        return;
      }

      // Download from API endpoint with cookie + token authentication
      const response = await fetch(API_ENDPOINTS.DOWNLOAD.LATEST_EXE, {
        method: 'GET',
        credentials: 'include',
        headers: getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error(`Download failed: ${response.status}`);
      }

      // Get the blob from the response
      const blob = await response.blob();
      
      // Create a temporary URL for the blob and trigger download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'BlackKiteAI.exe';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up the temporary URL
      window.URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error('Download error:', error);
      alert('Failed to download the desktop app. Please try again or check your internet connection.');
    } finally {
      // Reset button state after a brief delay
      setTimeout(() => {
        setIsDownloading(false);
      }, 2000);
    }
  };

  return (
    <div className="desktop-app-download">
      <div className="desktop-app-card">
        <div className="desktop-app-header">
          <div className="desktop-app-icon">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2" y="4" width="28" height="20" rx="2" stroke="currentColor" strokeWidth="2"/>
              <path d="M8 24H24" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M14 24V28M18 24V28" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          <div className="desktop-app-title">
            <h3>BlackKite Desktop App</h3>
          </div>
        </div>

        <div className="desktop-app-description">
          <p>Experience BlackKite AI on desktop with enhanced performance. The application operates quietly in the background and remains completely hidden from interviewers and meeting participants, giving you a private, distraction-free AI assistant throughout your interview experience.</p>
        </div>

        <div className="desktop-app-features">
          <ul>
            <li>Native Windows application</li>
            <li>Improved performance</li>
            <li>System integration</li>
            <li>Quick access</li>
          </ul>
        </div>

        <button 
          className={`btn-download-desktop ${isDownloading ? 'downloading' : ''}`}
          onClick={handleDownload}
          disabled={isDownloading}
        >
          {isDownloading ? (
            <>
              <span className="download-spinner"></span>
              Downloading...
            </>
          ) : (
            <>
              <span className="download-icon">⬇</span>
              Download for Windows
            </>
          )}
        </button>

        <p className="desktop-app-size">File size: ~70 MB</p>
      </div>
    </div>
  );
}

export default DesktopAppDownload;
